import React from 'react';
import styled from 'styled-components/macro';
import { sizePalette } from '../../utils/styleConstants';

export interface Props {
  imageUrl: string;
  bannerTitle: string;
  onSelection: () => void;
  isSelected: boolean;
}

const BannerContainer = styled.div<{ isSelected: boolean }>`
  min-width: ${sizePalette.spacing.pxToRem(156)};
  max-width: ${sizePalette.spacing.pxToRem(356)};
  border-radius: ${sizePalette.borderRadius['lg']};
  cursor: pointer;
  box-shadow: ${sizePalette.boxShadow.md};
  overflow: hidden;
`;

const ImageContainer = styled.div<{ imageUrl: string; isSelected: boolean }>`
  background-image: ${({ imageUrl }) => imageUrl && `url(${imageUrl})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: ${sizePalette.spacing.pxToRem(106)};
  width: ${sizePalette.size.full};
  border: ${({ theme, isSelected }) =>
    isSelected
      ? theme.colorPalette.isDarkMode
        ? `${sizePalette.borderWidth.DEFAULT} solid ${theme.colorPalette.turquoise.accent}`
        : `${sizePalette.borderWidth.DEFAULT} solid ${theme.colorPalette.turquoise.dark}`
      : `${sizePalette.borderWidth.DEFAULT} solid transparent`};
  border-top-left-radius: ${sizePalette.borderRadius['lg']};
  border-top-right-radius: ${sizePalette.borderRadius['lg']};
  border-bottom: none;
`;

const BannerLinkContainer = styled.div<{ isSelected: boolean }>`
  height: ${sizePalette.spacing.pxToRem(50)};
  width: ${sizePalette.size.full};
  display: flex;
  align-items: center;
  border: ${({ theme, isSelected }) =>
    isSelected
      ? theme.colorPalette.isDarkMode
        ? `${sizePalette.borderWidth.DEFAULT} solid ${theme.colorPalette.turquoise.accent}`
        : `${sizePalette.borderWidth.DEFAULT} solid ${theme.colorPalette.turquoise.dark}`
      : `${sizePalette.borderWidth.DEFAULT} solid transparent`};
  border-top: none;
  border-bottom-left-radius: ${sizePalette.borderRadius['lg']};
  border-bottom-right-radius: ${sizePalette.borderRadius['lg']};
  padding: ${sizePalette.spacing[2.5]};
  background-color: ${({ theme, isSelected }) =>
    isSelected
      ? theme.colorPalette.isDarkMode
        ? theme.colorPalette.turquoise.dark
        : theme.colorPalette.turquoise.dark
      : theme.colorPalette.isDarkMode
      ? theme.colorPalette.grey.grey3
      : theme.colorPalette.grey.grey9};
  color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.white)};
  justify-content: center;
`;

const BannerComponent = (props: Props) => {
  const { imageUrl, bannerTitle, onSelection, isSelected } = props;
  return (
    <BannerContainer isSelected={isSelected} onClick={onSelection}>
      <ImageContainer imageUrl={imageUrl} isSelected={isSelected} data-testid="image-container" />
      <BannerLinkContainer data-testid="linkToWebSite" isSelected={isSelected}>
        {bannerTitle}
      </BannerLinkContainer>
    </BannerContainer>
  );
};

export default BannerComponent;
